import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import CenteredCol from './shared/CenteredCol';

const Locations = props => (
    <section style={{backgroundColor: "#f3f2f0"}}>
        <Grid fluid>
            <Row>
                <Col xs={12}>
                    <Row center="xs" style={{paddingBottom: 0}}>
                        <Col xs={6}>
                            <h3>Service Areas</h3>
                            <ul style={{listStyle:"none", padding:0}}>
                                <li>Woodstock</li>
                                <li>Roswell</li>
                                <li>Milton</li>
                                <li>Dacula</li>
                                <li>Suwanee</li>
                                <li>Buford</li>
                                <li>Duluth</li>
                                <li>Norcross</li>
                                <li>Johns Creek</li>
                            </ul>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Grid>
    </section>
);

export default Locations;


// WEBPACK FOOTER //
// ./src/components/Locations.js